"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagMrIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagMrIcon = (0, _mobxReact.observer)(_class = (_FlagMrIcon = /*#__PURE__*/function (_React$Component) {
  function FlagMrIcon() {
    _classCallCheck(this, FlagMrIcon);
    return _callSuper(this, FlagMrIcon, arguments);
  }
  _inherits(FlagMrIcon, _React$Component);
  return _createClass(FlagMrIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 99 99"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M0 0h99v99H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF9600",
        d: "M58.8 50H0V0h98.8z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M36.8 41H22.7l-10-10V17l10-10h14.1l10 10v14.1l-10 9.9zm-12.9-3h11.6l8.2-8.2V18.2L35.5 10H23.9l-8.2 8.2v11.6l8.2 8.2z",
        fill: "#C92013"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M35.2 37.3h-11l-7.8-7.8v-11l7.8-7.8h11l7.8 7.8v11l-7.8 7.8zm-10.1-2h9.4l6.6-6.6v-9.4l-6.6-6.6h-9.4l-6.6 6.6v9.4l6.6 6.6z",
        fill: "#C92013"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        fill: "#C92013"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M23.2 17h13.1v2H23.2z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M33.8 18.4h2v11.7h-2z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M25.7 30c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9h.9v-5.6h2v5.6h6v2h-6v.9c0 1.6-1.3 2.9-2.9 2.9zm0-3.8c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9v-.9h-.9z"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagMrIcon.defaultProps = {
  width: '20px'
}, _FlagMrIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagMrIcon);